import gruposSegurosNovaCoop from './novacoop/gruposSeguros.json';
import gruposSegurosExecnet from './execnet/gruposSeguros.json';

export default function insurerGroupByTenant(tenant) {
  if (tenant && tenant.toUpperCase() === 'EXECNET') {
    return gruposSegurosExecnet;
  }
  return gruposSegurosNovaCoop;
}
